"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableReference = void 0;
var index_1 = require("../api/index");
var encode_1 = require("../utils/encode");
// import { useUserStore } from "@/store/user";
var useStorage_1 = require("../utils/useStorage");
/**
 * 表模块
 *
 * */
var TableReference = /** @class */ (function () {
    function TableReference(tableName, config, instance) {
        this.table_name = tableName;
        this.filter_params = null;
        this.config = config;
        this.API = new index_1.default(config, instance);
    }
    TableReference.prototype.saveProjectToken = function (tableName, enCodeStr) {
        // const userStore = useUserStore();
        // userStore.setProjectToken(tableName ? enCodeStr : "");
        (0, useStorage_1.setStorage)("projectToken", enCodeStr);
    };
    /**
       * 验证表
       * ProjectToken生成方式:对请求表名如:{lf_cms_lefan_use}进行AES加密后再使用base64加密得到的密文
         伪代码:Base64encode(aes(lf_cms_lefan_use,key,iv))
         AES使用的key和iv分别为截取前16位的appkey和appsecret*
    */
    TableReference.prototype.checkTable = function (tableName) {
        var enCodeStr;
        enCodeStr = (0, encode_1.encrypt)(tableName, this.config.app_split_key, this.config.app_split_secret);
        this.saveProjectToken(tableName, enCodeStr);
    };
    /**
     * 获取表数据
     **/
    TableReference.prototype.get = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.getList(params, this.filter_params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 获取表明细
     **/
    TableReference.prototype.detail = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.getDetail(id)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     *  添加表数据
     */
    TableReference.prototype.add = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.addData(params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     *  删除表数据
     *  id是数据id
     */
    TableReference.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.deleteData(id)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     *  批量删除表数据
     *  id是数据id
     */
    TableReference.prototype.multiDelete = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.deleteMultiData(params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     *  修改表数据
     */
    TableReference.prototype.update = function (id, params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.updateData(id, params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     *  上传文件
     */
    TableReference.prototype.upload = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.checkTable(this.table_name);
                        return [4 /*yield*/, this.API.uploadFile(params)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 参数过滤
     */
    TableReference.prototype.where = function (filterParams) {
        if (filterParams === void 0) { filterParams = null; }
        this.filter_params = filterParams;
        // return new TableReference(this.table_name,filterParams)
        return this;
    };
    return TableReference;
}());
exports.TableReference = TableReference;
